module.exports = __webpack_public_path__ + "pcstatic/img/register-img_01.7048d41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/register-img_01.png
// module id = CkLz
// module chunks = 2